import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import {
  Controller,
  ControllerRenderProps,
  useFormContext,
} from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  InternalStateAccumulationsFormValues,
  SingleCalculationRow,
} from "../../types";
import { Fragment } from "react";

type Props = {
  headers: string[];
  renderField: (
    subKey: string,
    field: ControllerRenderProps<InternalStateAccumulationsFormValues, any>,
  ) => JSX.Element;
};

const AccumulationsSingleCalculationTable = ({
  headers,
  renderField,
}: Props) => {
  const { t } = useTranslation("talentProfile");

  const { control, watch } = useFormContext();
  const fields = watch();

  // filter completedLimits from fields
  const filteredFields = fields.rows.filter((row: SingleCalculationRow) =>
    Object.keys(row).filter((key) => key !== "completedLimits"),
  );

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{t("accumulationKeys.modificationDate")}</TableCell>
            {headers.map((header) => (
              <TableCell key={header} align="right">
                {header === "workTime"
                  ? t(`accumulationKeys.workTimeSingle`)
                  : t(`accumulationKeys.${header}`)}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>
              <Controller
                name="modificationDate"
                control={control}
                render={({ field }) => (
                  <DesktopDatePicker
                    {...field}
                    format="dd.MM.yyyy"
                    slotProps={{
                      textField: {
                        size: "small",
                      },
                    }}
                  />
                )}
              />
            </TableCell>
            <TableCell colSpan={13} />
          </TableRow>
          {filteredFields.map((row: SingleCalculationRow, index: number) => (
            <Fragment key={index}>
              <TableCell />
              {Object.keys(row).map((key) => (
                <TableCell align="right">
                  <Controller
                    control={control}
                    name={`rows.${index}.${key}`}
                    render={({ field }) => renderField(key, { ...field })}
                  />
                </TableCell>
              ))}
            </Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AccumulationsSingleCalculationTable;
